export default __webpack_public_path__ + "static/media/hdro.ed9ac2d5.png";